import { Component } from '@angular/core';
import { ToastService } from '../../../../services/toast.service';
import { Material } from '../../../../types/Material.type';
import { MaterialService } from '../../../../services/material.service';

@Component({
  selector: 'app-materiais',
  templateUrl: './materiais.component.html',
  styleUrl: './materiais.component.css'
})
export class MateriaisComponent {

  materiais!: Material[]
  loading: boolean = true
  loadingSincronizar: boolean = false

  constructor(private materialService: MaterialService, private toastService: ToastService){}

  ngOnInit(){
   this.getMateriais()
  }

  getMateriais(){
    this.materialService.getAll().subscribe({
      next: (data) => {
        this.materiais = data
      },
      error: (error) => {
        this.toastService.erro(error.error.title, "Erro ao sincronizar: " + error.error.detail);

      },
      complete: () => {
        this.loading = false
      }
    })
  }

  exportar() {

    this.loadingSincronizar = true;

    this.materialService
      .exportar()
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'materiais.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
          this.loadingSincronizar = false;
        },
        complete: () => {
          this.loadingSincronizar = false;
        },
      });
  }

}
